export default {
      id: "paymentmethods-usage",
      viewBox: "0 0 22 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#paymentmethods",
      toString: function () {
        return this.url;
      }
    }